import { z } from 'zod';
export const RegisterDeviceRequestSchema = z.object({
    name: z.string().min(1).max(100),
    type: z.enum(['cli', 'web', 'codespace', 'server']),
    platform: z.string().optional(),
    hostname: z.string().optional(),
    metadata: z.record(z.any()).optional(),
});
export const RegisterDeviceResponseSchema = z.object({
    device: z.object({
        id: z.string().uuid(),
        name: z.string(),
        type: z.string(),
        orgId: z.string().uuid(),
        createdAt: z.string().datetime(),
    }),
    serviceToken: z.string(),
    expiresAt: z.string().datetime(),
});
export const ListDevicesRequestSchema = z.object({
    orgId: z.string().uuid().optional(),
    includeRevoked: z.boolean().optional().default(false),
});
export const ListDevicesResponseSchema = z.object({
    devices: z.array(z.object({
        id: z.string().uuid(),
        name: z.string(),
        type: z.string(),
        platform: z.string().nullable(),
        hostname: z.string().nullable(),
        lastSeenAt: z.string().datetime().nullable(),
        deletedAt: z.string().datetime().nullable(),
        createdAt: z.string().datetime(),
    })),
});
export const RevokeDeviceRequestSchema = z.object({
    deviceId: z.string().uuid(),
    reason: z.string().optional(),
});
export const RevokeDeviceResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
});
export const VerifyTokenRequestSchema = z.object({
    token: z.string().min(1),
});
export const VerifyTokenResponseSchema = z.object({
    valid: z.boolean(),
    device: z.object({
        id: z.string().uuid(),
        orgId: z.string().uuid(),
        userId: z.string().uuid().nullable(),
        name: z.string(),
        type: z.string(),
    }).optional(),
    error: z.string().optional(),
});
export const AuthContextSchema = z.object({
    userId: z.string().uuid().optional(),
    email: z.string().email().optional(),
    deviceId: z.string().uuid(),
    deviceType: z.string(),
    orgId: z.string().uuid(),
    authMethod: z.enum(['user_token', 'device_token']),
});
export const AuthErrorResponseSchema = z.object({
    error: z.string(),
    code: z.enum([
        'UNAUTHORIZED',
        'INVALID_TOKEN',
        'TOKEN_EXPIRED',
        'DEVICE_REVOKED',
        'INSUFFICIENT_PERMISSIONS',
    ]),
    message: z.string(),
});
//# sourceMappingURL=auth-contracts.js.map